// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2g9dA","box":"WorkspacesBox_box__39-JR","node":"WorkspacesBox_node__1DFK4"};